import { validateDatePair } from '@/core/validators';

export default function validateFromAndTo(obj) {
	let errors = {};
	let emptyDate = {
		epoch: 0,
		hasTime: true,
		timeZone: 'Europe/Oslo'
	};
	[errors.atd, errors.ata] = validateDatePair(obj.atd || emptyDate, obj.ata || emptyDate);

	return errors;
}